export { default } from "./Triggerable";
